(() => {
  if (window.Shopify?.designMode) return;

  let attempts = 0;
  const openForm = () => {
    if (window.withdrawalModal?.open) {
      const overlay = document.getElementById('wb-modal-overlay');
      if (!overlay?.classList.contains('wb-active')) window.withdrawalModal.open();
      return;
    }
    if (++attempts < 40) window.setTimeout(openForm, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openForm, { once: true });
  } else {
    openForm();
  }
})();
